import React, { useCallback, useContext } from 'react'
import { Autocomplete, Breadcrumbs, Grid, Link, TextField, Typography, useMediaQuery } from '@mui/material'
import globalStyles from '../../assets/styles/global.module.scss'
import { GenericDataContext, GenericDataContextPayload } from '../../context/genericDataContext';
import { UserContext, UserContextPayload } from '../../context/userContext';
import { timezoneList } from '../../models/axiosModel';
import agent from '../../services/api';
import { useNavigate } from 'react-router-dom';
import BreadCrumb from '../global/breadCrumb';
import clsx from "clsx";
import { useGenericStore } from '../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

const GlobalPageHeaderText = (props: any) => {
    const navigate = useNavigate()
    const mobileScreen: boolean = useMediaQuery('(min-width: 0px) and (max-width: 599px)');
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    
    const { genericTimezoneList } = useContext(GenericDataContext) as GenericDataContextPayload
    const { userDetail, setUserDetail, setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    
    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const updateUserTimezone = useCallback(async (value: timezoneList) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        let payload = {
            timezone_id: value.timezone_id
        }
        const response = await agent.updateUserTimezone.put(payload)
        if (response.status) {
            showSuccess("Timezone updated Successfully!")
            setUserDetail((prevState) => ({ ...prevState, timezone_id: value.timezone_id, timezone_hour: value.timezone_hour, timezone_name: value.timezone_name, timezone_standard_name: value.timezone_standard_name }))
        } else {
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }, [genericTimezoneList, userDetail, setUserDetail, setFlagLoading, handleError])

    const getTimeZoneValue = useCallback(() => {
        return genericTimezoneList.find((timezone) => timezone.timezone_id === userDetail.timezone_id) ?? null;
    }, [genericTimezoneList, userDetail])

    return (
        <>
            <Grid container gap={{ xs: "0px", lg: '15px' }} className={globalStyles.wrapperGlobalPageHeader} flexWrap={{ md: "nowrap" }}>
                {/* left block */}
                <Grid item xs={11} sm={11} md={11} lg={10} xl={5.5} sx={{ display: props.flagMainTextOnly ? "flex" : "", alignItems: props.flagMainTextOnly ? "center" : "" }}>
                    <Grid container>
                        {mobileScreen ? (<></>) : (
                            <Grid item xs={12}>
                                <Typography
                                    component={'span'}
                                    className={`${globalStyles.globalHeadText} ${globalStyles.globalHeaderFontSize} ${globalStyles.globalHeaderFontWeight}`}
                                >
                                    {props.mainHeadText}
                                </Typography>
                            </Grid>
                        )}
                        <Grid item xs={12} sx={{ marginBottom: { xs: !props.flagMainTextOnly ? "10px" : "0px", sm: "0px" } }}>
                            <Typography
                                component={'span'}
                                className={`${globalStyles.globalDecsText}`}
                            > 
                                {props.mainSubText ?  
                                    props.mainSubText 
                                    :  
                                    (!smallScreen) &&
                                    <BreadCrumb />
                                }

                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={11} sm={11} md={props.actionBlock ? 11 : 3} lg={props.actionBlock ? 11 : 4} xl={5.5}>
                    <Grid container className={`${globalStyles.autoCompleteWrapper} ${globalStyles.globalPageHeaderTextActionBlockContainer}`}>
                        {props.actionBlock}
                        {props.flagTimezone &&
                            <Grid item className={globalStyles.globalHeaderTimeZoneGrid} padding={props.flagMainTextOnly ? "0px" : ""}>
                                <Grid container className={`${globalStyles.containerFlexWrap} ${globalStyles.centerAlignment}`} >
                                    {/* <Box sx={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <img src={timezoneImg} alt="timezone" style={{ width: "25px", height: "25px" }} />
                                    </Box> */}
                                    <Autocomplete
                                        className={globalStyles.textVariantAutocompleteStyle}
                                        options={genericTimezoneList}
                                        getOptionLabel={(option) => option.timezone_name}
                                        renderInput={(params) => (<TextField {...params} />)}
                                        value={getTimeZoneValue()}
                                        ListboxProps={{ className: clsx(globalStyles.secondaryFontSize, globalStyles.secondaryFontWeight)  }}
                                        onChange={(event, value) => {
                                            if (value) {
                                                updateUserTimezone(value)
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>}
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default GlobalPageHeaderText